import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)

export class SupplierApi {
	constructor () {
		this.url = process.env.NODE_ENV === 'development'
    			? 'https://sigma.quomi.it:8214/v1'
        		: process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	all (params) {
		return Vue.http.get(this.url + '/suppliers', {})
	}

  origin (params) {
    return Vue.http.get(this.url + '/product/origins', {})
  }
}
